import { Component, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { overlayConfigFactory } from 'angular2-modal';
import { Modal, BSModalContext } from 'angular2-modal/plugins/bootstrap';
import { AppSettings, enumStatusCodeList } from '../../sharedcomponents/_common/constants/app.constants';
import { ErrorPopupComponent } from '../../sharedcomponents/_directive/error-popup/error-popup.component';
import { AlertPopupComponent } from '../../sharedcomponents/_directive/alert-popup/alert-popup.component';
import { loyaltylogin } from '../../_services/userservice/user.loyaltylogin.service';
import { TranslateService } from 'ng2-translate/ng2-translate';
//Service Section
import { AuthService } from '../../_services/userservice/auth.service';
import { UserService } from '../../_services/userservice/user.service';
import { AlertService } from '../../sharedcomponents/commonservice/alert.service';
import { CountryService } from '../../sharedcomponents/commonservice/countrylist.service';
import { CountryDetail } from '../../sharedcomponents/_common/countrylist/countryinformation';
import { utilityService } from '../../sharedcomponents/commonservice/utility.service';
import { VerifyMobileComponent } from './RegistrationPopup/verify-mobile/verify-mobile.component';
import { LinkUserComponent } from './RegistrationPopup/link-user/link-user.component';
import { UserInfoComponent } from './RegistrationPopup/user-info/user-info.component';
import { geolocation } from '../../sharedcomponents/commonservice/geolocation/geoloc';
import { AboutUsComponent } from '../../sharedcomponents/about-us/about-us.component';
import { UserProfileTMNIovation, enumEventype } from '../../models/user/user.tm.profile.model';
import { loyaltyCardverificationComponent } from '../loyalty-login/loyalty-login.component-Step2';
import { GoogleAnalyticsEventsService } from '../../sharedcomponents/commonservice/googleAnalytics/google-analytics-events-service.service';
import { User } from '../../models/user/user';

import { ThreatMetrixService } from '../../_services/ThreatMetrix/threatmetrix'

@Component({
  moduleId: module.id,
  selector: 'app-user-register',
  templateUrl: './user-register.component.html',
  styleUrls: ['./user-register.component.css'],
  encapsulation: ViewEncapsulation.None,
  providers: [UserService, AlertService, Modal, CountryService, AuthService, ThreatMetrixService]
})
export class UserRegisterComponent implements OnInit {
  userProfileTMNIovation: UserProfileTMNIovation;
  model: any = {};
  loyaltymodel: any = {};
  formReadOnly: boolean = false;
  EmailNew: string = '';
  PhoneNew: string = '';
  isLoyaltyCardReg: boolean = false;
  mobilePre = '0';
  loading = false;
  x2js: any;
  countryinfo: CountryDetail;
  preferredCountry: any;
  appSettings: any = {};
  private subProfile = new Subject<boolean>();
  fraudDetectionPromise: Promise<any>;
  private _newPassword: string = '';

  get NewPassword(): string {
    return this._newPassword;
  }

  set NewPassword(value: string) {
    this._newPassword = value;
  }

  @Output()
  subProfileObservable = this.subProfile.asObservable();
  countrycollection = new Array<CountryDetail>();
  constructor(
    private translate: TranslateService,
    private userService: UserService,
    private alertService: AlertService,
    public modal: Modal,
    private countryserv: CountryService,
    public utilserv: utilityService,
    private loyallog: loyaltylogin,
    public geoloc: geolocation,
    private auth: AuthService,
    public googleAnalyticsEventsService: GoogleAnalyticsEventsService,
    private router: Router,
    private threatMetrixService: ThreatMetrixService
  ) {
    this.countrycollection = this.countryserv.getCountryListFromLocale();
    this.preferredCountry = this.countrycollection.filter(function (country) {
      return country.isOrigin == true;
    });

    this.appSettings = AppSettings;

  }

  ngOnInit() {
    this.threatMetrixService.Init();
    this.model = new User();
    this.model.confirmEmail = "";
    this.model.confirmMobile = "";
    this.model.mobilePrefix = this.mobilePre;
    this.model.countryPreference = '';
    this.loyallog.getEditUserData().subscribe(data => {
      if (data == null) {
        return false;
      }
      this.formReadOnly = true;
      this.isLoyaltyCardReg = true;
      this.model.methodName = sessionStorage.methodName;
      this.model.loyaltyCardNumber = sessionStorage.loyaltyCardNumber != undefined ? sessionStorage.loyaltyCardNumber : '';
      this.loadUserData(data);
    });
    this.model.mobilePrefix = 1; // Will remain Only US -Change Requirment
  }
  //Function will intitated Country List and Save on a session variable going forward will use this for getting Country related information

  onChange(contryCode) {
    this.countrycollection.filter(function (country) {
      return country.CountryCode == contryCode;
    });
    // if (mobilePre.length > 0)
    //     this.model.mobilePrefix = mobilePre[0].CountryDialingCode;
    // else { this.model.mobilePrefix = this.mobilePre }
  }

  register() {
    this.loading = true;
    const _self = this;
    this.userProfileTMNIovation = new UserProfileTMNIovation();
    this.userProfileTMNIovation.deviceProfile.SessionID = localStorage.sessionId;
    this.userProfileTMNIovation.deviceProfile.IovationBlackBoxKey = sessionStorage.iovationBBKey;
    this.userProfileTMNIovation.eventType = enumEventype[enumEventype.Ragistration];
    ///////////////////User Model
    // const user = new User();
    // user.additionalLastName = this.model.lastName
    // this.userProfileTMNIovation.userProfile = this.model;
    this.userProfileTMNIovation.userProfile.additionalLastName = this.model.additionalLastName;
    this.userProfileTMNIovation.userProfile.countryPreference = this.model.countryPreference;
    this.userProfileTMNIovation.userProfile.email = this.model.email;
    this.userProfileTMNIovation.userProfile.firstName = this.model.firstName;
    this.userProfileTMNIovation.userProfile.lastName = this.model.lastName;
    this.userProfileTMNIovation.userProfile.mobile = this.model.mobile;

    if (this.isLoyaltyCardReg) {
      if (this.EmailNew != this.model.email) {
        this.model.IsEmailNew = true;
      }
      if (this.PhoneNew != this.model.mobile) {
        this.model.IsPhoneNew = true;
      }
    }

    if (!_self.fraudDetectionPromise) {

      _self.fraudDetectionPromise = new Promise((resolve, reject) => {

        _self.threatMetrixService.Profile().then(sessionId => {
          _self.userProfileTMNIovation.deviceProfile.SessionID = sessionId;
          _self.utilserv.busy = _self.auth.profileTMnIovation(_self.userProfileTMNIovation).subscribe(data => {

            if (data.Envelope.Body.FraudDetectionResponse.StatusCode == 10000) {

              sessionStorage.publicKeyRSA = data.Envelope.Body.FraudDetectionResponse.RSAPublicKey;
              sessionStorage.KeyUID = data.Envelope.Body.FraudDetectionResponse.KeyUID;
              
              resolve(data);
              
            } else {
              reject(data);
            }
          });
        });
      });
   }

   _self.fraudDetectionPromise.then(x => {

    _self.model.password = _self._newPassword;

    _self.utilserv.busy = _self.userService.registerUser(_self.model).subscribe(data => {
      _self.userResponsehandle(data);
    });
   }, x => {
    const modalData: any = {};
        modalData.Title = _self.translate.instant('Common_lblInfo');
        modalData.Message = _self.translate.instant('Message_errorMessage');
        _self.modal.open(ErrorPopupComponent, overlayConfigFactory({ modalData }, BSModalContext));
   });
  }

  userResponsehandle(data) {
    const resJSON = data;
    this.model.UserID = this.utilserv.getObjectText(resJSON.Envelope.Body.CustomerInfoResponse.UserID);
    this.model.RegistrationCode = this.utilserv.getObjectText(resJSON.Envelope.Body.CustomerInfoResponse.RegistrationCode);
    this.model.MobileNumber = this.utilserv.getObjectText(resJSON.Envelope.Body.CustomerInfoResponse.MobileNumber);
    this.model.CustomerEmail = this.utilserv.getObjectText(resJSON.Envelope.Body.CustomerInfoResponse.CustomerEmail);
    // this.model.CustomerInfo= this.utilserv.getObjectText(resJSON.Envelope.Body.CustomerInfo.KeyUID);

    this.formReadOnly = false;
    if (resJSON.Envelope.Body.CustomerInfoResponse.StatusCode == enumStatusCodeList.UserIsAlreadyExist) {
      this.loading = false;
      const modalData: any = {};
      modalData.Title = this.translate.instant('Common_lblInfo').toString();
      modalData.Message = resJSON.Envelope.Body.CustomerInfoResponse.StatusMessage;
      this.modal.open(ErrorPopupComponent, overlayConfigFactory({ modalData }, BSModalContext));
    } else if (resJSON.Envelope.Body.CustomerInfoResponse.StatusCode == 8016) {
      this.loading = false;
      this.alertService.openErrorAlert(this.translate.instant("Common_lblInfo"), this.translate.instant("Common_InvalidPhoneNumber"));
    } else if (
      resJSON.Envelope.Body.CustomerInfoResponse.StatusCode == enumStatusCodeList.EmailAndPhoneNotVerified ||
      resJSON.Envelope.Body.CustomerInfoResponse.StatusCode == enumStatusCodeList.PhoneNotVerified
    ) {
      this.loading = false;
      this.verifyMobilePopup(this.model);

    } else if (resJSON.Envelope.Body.CustomerInfoResponse.StatusCode == enumStatusCodeList.UserIsAlreadyExistWithICE) {
      this.loading = false;
      this.linkUserPopup(this.model);
    } else if (resJSON.Envelope.Body.CustomerInfoResponse.StatusCode == enumStatusCodeList.EmailNotVerified) {
      const message = this.translate.instant('EmailConfirmPopup_desc');
      this.loading = false;
      this.openInfoPopup(message);
    } else if (resJSON.Envelope.Body.CustomerInfoResponse.StatusCode == enumStatusCodeList.SUCCESS) {
      this.loading = false;
      const message = this.translate.instant('Registration_lblRegistrationSuccess');
      this.openInfoPopup(message);
    } else if (resJSON.Envelope.Body.CustomerInfoResponse.StatusCode == enumStatusCodeList.userProfileUpdated) {
      this.loading = false;
      this.openInfoPopup(resJSON.Envelope.Body.CustomerInfoResponse.StatusMessage);
    } else if (resJSON.Envelope.Body.CustomerInfoResponse.StatusCode == enumStatusCodeList.loylty_timeout) {
      this.loading = false;
      const modalData: any = {};
      const _self = this;
      modalData.Title = _self.translate.instant('Common_lblOops');
      modalData.Message = resJSON.Envelope.Body.CustomerInfoResponse.StatusMessage;
      modalData.Action = _self.translate.instant('Common_lblContinue');
      this.modal.open(AlertPopupComponent, overlayConfigFactory({ modalData }, BSModalContext)).then(function (obj) {
        obj.onDestroy.subscribe(data => {
          // navigate to login screen
          _self.router.navigate(['/login']);
        });
      });
    } else {
      this.loading = false;
      const modalData: any = {};
      modalData.Title = this.translate.instant('Common_lblInfo').toString();
      modalData.Message = resJSON.Envelope.Body.CustomerInfoResponse.StatusMessage;
      this.modal.open(ErrorPopupComponent, overlayConfigFactory({ modalData }, BSModalContext));
    }
  }
  verifyMobilePopup(user: any) {
    const self = this;
    let modalData: any = {};
    modalData.user = user;

    this.modal.open(VerifyMobileComponent, overlayConfigFactory({ modalData }, BSModalContext)).then(function (obj) {
      obj.onDestroy.subscribe(error => {
        console.log('Observer got a next value: ' + error);
        if (modalData.next == 'yes') {
          self.router.navigate(['/login']);
        }
      });
    });
  }
  linkUserPopup(user: any) {
    const _self = this;
    const modalData: any = {};
    modalData.user = user;
    return this.modal.open(LinkUserComponent, overlayConfigFactory({ modalData }, BSModalContext)).then(function (obj) {
      obj.onDestroy.subscribe(data => {
        console.log('Observer got a next value: ' + data);
        if (modalData.status == 'yes') {
          let loyaltyCardModel: any = modalData.user;
          loyaltyCardModel.OTPName = 'RegistrationCode';
          loyaltyCardModel.OTPValue = modalData.user.RegistrationCode;
          loyaltyCardModel.MobileNumber = modalData.user.MobileNumber;
          loyaltyCardModel.CustomerEmail = modalData.user.CustomerEmail;
          return _self.modal.open(loyaltyCardverificationComponent, overlayConfigFactory({ loyaltyCardModel }, BSModalContext));
        } else if (modalData.status == 'no') {
          // send registration code with lang
          let user = modalData.user;
          _self.utilserv.busy = _self.userService.SendRegistrationCode(user).subscribe(data => {
            _self.userResponsehandle(data);
          });
        }
      });
    });
  }
  openInfoPopup(infoMessage) {
    return this.modal.open(UserInfoComponent, overlayConfigFactory({ infoMessage }, BSModalContext));
  }

  loadUserData(data) {
    this.loading = true;
    this.loading = false;
    this.model.UserID = this.utilserv.getObjectText(data.UserID) != '' ? this.utilserv.getObjectText(data.UserID) : '';
    this.model.firstName = this.utilserv.getObjectText(data.FirstName) != '' ? this.utilserv.getObjectText(data.FirstName) : '';
    this.model.countryPreference = this.utilserv.getObjectText(data.PreferCountryCode) != '' ? this.utilserv.getObjectText(data.PreferCountryCode) : '';
    this.model.middleName = ''; //  this.utilserv.getObjectText(data.MiddleName); --Commented due to requirment changes
    this.model.mobile = this.utilserv.getObjectText(data.MobileNumber) != '' ? this.utilserv.getObjectText(data.MobileNumber) : '';
    this.model.confirmMobile = this.model.mobile;
    this.model.lastName = this.utilserv.getObjectText(data.LastName) != '' ? this.utilserv.getObjectText(data.LastName) : '';
    this.model.additionalLastName = this.utilserv.getObjectText(data.AdditionalLastName) != '' ? this.utilserv.getObjectText(data.AdditionalLastName) : '';
    this.model.email = this.utilserv.getObjectText(data.CustomerEmail) != '' ? this.utilserv.getObjectText(data.CustomerEmail) : '';
    this.model.confirmEmail = this.model.email;
    this.model.termsUse = true;

    this.EmailNew = this.utilserv.getObjectText(data.CustomerEmail);
    this.PhoneNew = this.utilserv.getObjectText(data.MobileNumber);

    this.loyaltymodel.firstName = this.utilserv.getObjectText(data.FirstName) != '' ? this.utilserv.getObjectText(data.FirstName) : '';
    this.loyaltymodel.lastName = this.utilserv.getObjectText(data.FirstName) != '' ? this.utilserv.getObjectText(data.LastName) : '';
    this.loyaltymodel.mobile = this.utilserv.getObjectText(data.FirstName) != '' ? this.utilserv.getObjectText(data.MobileNumber) : '';
    this.loyaltymodel.email = this.utilserv.getObjectText(data.FirstName) != '' ? this.utilserv.getObjectText(data.CustomerEmail) : '';
  }
  onComponentChange() { }
  callCustomerCare() {
    let CountryObject: any = this.geoloc.getCountryObject();
    if (CountryObject.CustomerCareNumber && CountryObject.CustomerCareNumber != undefined) {
      this.alertService.openErrorAlert(
        this.translate.instant('Common_lblInfo'),
        this.translate.instant('Message_lblCustomerCareContactPrefix') + ' ' + CountryObject.CustomerCareNumber + ' ' + this.translate.instant('Message_lblCustomerCareContactSuffix')
      );
    } else {
      this.alertService.openErrorAlert(this.translate.instant('Common_lblInfo'), this.translate.instant('Message_customerCareError'));
    }
  }

  opentermsofuse(objtext) {
    let modalData: any = {};
    modalData.Title = this.translate.instant('Common_lblTermsConditions');
    modalData.URL = objtext;
    modalData.Action = this.translate.instant('Common_lblOk');
    return this.modal.open(AboutUsComponent, overlayConfigFactory({ modalData }, BSModalContext));
  }

  LengthPolicy(): boolean {
    return this._newPassword.length >= 8 && this._newPassword.length <= 15;
  }

  OneUppercaseLetterPolicy(): boolean {
    return /[A-Z]+?/.test(this._newPassword);
  }

  OneLowercaseLetterPolicy(): boolean {
    return /[a-z]+?/.test(this._newPassword);
  }

  OneDigitPolicy(): boolean {
    return /[0-9]+?/.test(this._newPassword);
  }

  OneSpecialCharPolicy(): boolean {
    return (new RegExp(this.appSettings.passwordSpecialCharPattern)).test(this._newPassword);
  }
}



// WEBPACK FOOTER //
// ./src/app/user/user-register/user-register.component.ts